export function transformInput(mask, currentInput) {
    let splitValue = currentInput.split("");
    let maskedInput = mask;
    let lastIndex = 0;

    if (splitValue != "" && splitValue.length > 0) {
        splitValue.forEach(x => {
            lastIndex = maskedInput.indexOf(" ");

            if (lastIndex === -1) {
                maskedInput = maskedInput + x;
                lastIndex = maskedInput.length - 1;
            }
            else {
                maskedInput = maskedInput.substr(0, lastIndex) + x + maskedInput.substr(lastIndex + 1);
            }
        });

        maskedInput = maskedInput.trim(" ");
    }
    else {
        maskedInput = "";
    }

    return { maskedInput, lastIndex };
}

